import React from 'react'
import "./Footer.css"
function Footer() {
    return (
        <div className='footer'>
            <small>
                <small class="right" >&copy; 2023 Airbnb.All Rights Reserved | Developed By <strong>Heet Doshi.</strong></small>
            </small>
        </div>
    )
}

export default Footer